import React from 'react';
import useComponentDidMount from 'Hooks/useComponentDidMount';

export default function useBodyScrollLock(shouldLockBodyScroll, alwaysUseAuto = true) {
  const prevBodyOverflowRef = React.useRef(null);

  useComponentDidMount(() => {
    prevBodyOverflowRef.current = window.document.body.style.overflowY;
  }, () => {
    window.document.body.style.overflowY = prevBodyOverflowRef.current;
  });

  React.useEffect(() => {
    if (shouldLockBodyScroll) {
      window.document.body.style.overflowY = 'hidden';
      return;
    }

    if (alwaysUseAuto) {
      window.document.body.style.overflowY = 'auto';
      return;
    }

    window.document.body.style.overflowY = prevBodyOverflowRef.current;
  }, [shouldLockBodyScroll]);
}
